import { render, staticRenderFns } from "./Trips.vue?vue&type=template&id=fe2070f0&scoped=true&"
import script from "./Trips.vue?vue&type=script&lang=js&"
export * from "./Trips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2070f0",
  null
  
)

export default component.exports